module.exports = __webpack_public_path__ + "images/fc72b4220a669b62be368f76599b41b1-no_sensors.png";